<template>
  <div class="task-comments p-1" :style="indentLevel">
    <div v-if="AreIdsShown" style="background-color: black; color: cyan">
      <!-- <div style="background-color: black; color: yellow">comment.commentId: {{ comment.commentId }}</div> -->
      <!-- <div style="background-color: black; color: yellow">comment.id: {{ comment.id }}</div> -->
      <!-- <div>{{ comment.commentOwner }}</div>
      <div>{{ comment.createdBy }}</div>
      <div>{{ comment.createdDate }}</div>
      <div>{{ comment.comment }}</div> -->

      <!-- <div  style="background-color: darkgreen; color: yellow;">
	   <div>canReply {{ comment.canReply }}</div>
      <div>canEdit {{ comment.canEdit }}</div>
      <div>canDelete {{ comment.canDelete }}</div>
	</div> -->
    </div>
    <!--  -->
    <!-- <h3  style="background-color: darkgoldenrod; color: yellow">PATIENT ID: {{ this.patientId }}</h3> -->
    <div :class="userStore.borderClass">
      <h6 v-if="AreIdsShown">AA modalTheme: {{ modalTheme }}</h6>

      <div class="d-flex top-row taskCommentContainer">
        <div class="top-left-info">
          <h5>{{ useFormatDateTime(comment.commentDate) }} {{ comment.commentOwner }}</h5>
        </div>
        <div class="ml-auto">
          <a v-if="comment.canReply" @click.prevent="replyComment" href="#">
            <b-badge href="#" variant="success">Reply</b-badge>
          </a>
          <a v-if="comment.canReply" @click.prevent="editComment" href="#">
            <b-badge href="#" variant="warning">Edit</b-badge>
          </a>
          <a v-if="comment.canDelete" @click.prevent="deleteComment" href="#">
            <b-badge href="#" variant="danger">Delete</b-badge>
          </a>

          <!-- <a v-if="canReply" @click.prevent="replyComment" href="#"><b-badge  pill variant="success" href="#">Reply</b-badge></a>
				<a v-if="canEdit" @click.prevent="editComment" href="#"><b-badge  pill variant="warning">Edit</b-badge></a>
				<a v-if="canDelete" @click.prevent="deleteComment" href="#"><b-badge  pill variant="danger">Delete</b-badge></a>-->
        </div>
      </div>
    </div>
    <div class="d-flex" style="max-height: 180px; overflow: auto">
      <!--  TESTING  <TaskCommentSaveCancelTextbox :value="replyValue" :onSave="postReplyComment" :onChange="replyChange" :onCancel="cancelReply" /> -->
      <template v-if="editing">
        <TaskCommentSaveCancelTextbox :value="comment.comment" :onSave="postEditComment" :onChange="editChange" :onCancel="cancelEdit" />
      </template>
      <template v-else-if="replying">
        <TaskCommentSaveCancelTextbox :value="replyValue" :onSave="postReplyComment" :onChange="replyChange" :onCancel="cancelReply" />
      </template>
      <template v-else>
        <div class="my-3 comment">{{ comment.comment }}</div>
      </template>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, computed } from "vue";
// * STOREs
import { useStoreUser } from "@/stores/userStore";
const userStore = useStoreUser();
import { useFormatDateTime } from "@/use/formatDate.js";
import { toast } from "vue3-toastify";

import TaskCommentSaveCancelTextbox from "@/components/TaskCommentSaveCancelTextbox.vue";

// ! API  discreteDataApi
import { replyTaskComment, editTaskComment, deleteTaskComment } from "@/api/discreteDataApi";

// & PROPS
const props = defineProps({
  comment: {
    Type: Array,
    Default: () => {},
  },
});

// * EMITTER
const emit = defineEmits(["reply-comment", "edit-comment", "delete-comment"]);
const modalTheme = computed(() => userStore.bModalTheme);

const AreIdsShown = ref(false);

const replying = ref(false);
// console.log("replying");
// console.log(replying);
const editing = ref(false);
// console.log("editing");
// console.log(editing);

const replyValue = ref("");
const editValue = ref(props.comment.commentText);

// console.log("+++++++++++++++++++++++++++");
// console.log();
// console.log();
// console.log();

// console.log("+++ REPLY and EDIT    CANCEL function   PASSes  05/31     ++++++++++++++++++++++++");
// console.log("+++++++++++++++++++++++++++");
// console.log("+++++++++++++++++++++++++++");

// * a computed ref
const canReply = computed(() => {
  return props.comment.canReply && !replying;
});
const canEdit = computed(() => {
  props.comment.canEdit && !editing;
});
const canDelete = computed(() => {
  return props.comment.canDelete;
});

// () isEmptyOrSpaces
const isEmptyOrSpaces = (str) => {
  return /^\s*$/.test(str) === true;
};

function edit() {
  this.editing = true;
}
function cancelEdit() {
// console.log("    cancelEdit");
// console.log();
// console.log();
// console.log();

  editing.value = false;
  editValue.value = props.comment.commentText;
}
function replyComment() {
  // console.clear()
// console.log("  replyComment    this.replaying = true");

  // console.log(' this.replying.value  : ',  this.replying.value )
// console.log();
// console.log();
  replying.value = true;

// console.log(" replying.value ");
// console.log(replying.value);
}
function editComment() {
  // this.editing.value = true;
// console.log(" editing.value ");
  editing.value = true;

// console.log(" editing.value ");
// console.log(editing.value);
}
function editChange(e) {
// console.log("               editChange ");
  editValue.value = e.target.value;
}
function replyChange(e) {
  replyValue.value = e.target.value;
}
function cancelReply() {
// console.log("cancelReply ");
// console.log();
// console.log();
  replying.value = false;
  replyValue.value = "";
}

async function postReplyComment() {
  //console.clear()()
// console.log("TASK COMMENT >  I AM REPLYING HERE     postReplyComment");

  if (isEmptyOrSpaces(replyValue.value)) {
    toast.error("Please enter a comment");
    return;
  }

  // console.log('commentID: ' + this.comment.commentId)
  //  console.log('Id: ' + this.comment.id)
  // console.log('replyText: ' + this.replyValue)
  // console.log('pId: ' + this.patientId)

  const response = await replyTaskComment({
    commentId: props.comment.commentId,
    Id: props.comment.id,
    replyText: replyValue.value,
    patientId: props.patientId,
  });

  if (response.ok) {
    replying.value = false;
    replyValue.value = "";
    //
// console.log("Resp.OK =  EMITTING from REPLY ");
    // this.$emit("reply-comment", {
    //   response,
    // });

    emit("reply-comment", response);
  } else {
    toast.error(response.message);
  }
}
async function postEditComment() {
  // console.log('🚀 ~ file: TaskComment.vue ~ line 109 ~ postEditComment ~')
// console.log("POST Edit Comment");

  if (editValue.value === props.comment.commentText) {
    toast.error("Please change comment in order to save");
    return;
  }
  if (isEmptyOrSpaces(editValue.value)) {
    toast.error("Please enter a comment");
    return;
  }

  const response = await editTaskComment({
    commentId: props.comment.commentId,
    Id: props.comment.id,
    editValue: editValue.value,
    patientId: props.patientId,
  });

  // console.log('RESp: ' + this.response)

  if (response.ok) {
    editing.value = false;
    editValue.value = "";

// console.log("Resp.OK =  EMITTING from EDITING ");
    // this.$emit("edit-comment", {      response,    });

    emit("edit-comment", response);
  } else {
    toast.error(response.message);
  }
}
async function deleteComment() {
  // console.log('🚀 ~ file: TaskComment.vue ~ line 176 ~ deleteComment ~')
// console.log("	>>>		>>>  DELETE >>>  Delete Comment");

  // console.log('CHECK IDs ')

  // console.log('cId: ' + this.comment.commentId + ' Id: ' + this.comment.id)

  const response = await deleteTaskComment({
    commentId: props.comment.commentId,
    Id: props.comment.id,
    patientId: props.patientId,
  });

// console.log("   NEW  EMITTER          Resp.OK =  EMITTING from DELETE ");
  // this.$emit("delete-comment", {    response,  });

  emit("delete-comment", response);

  if (!response.ok) {
    toast.error(response.message);
  }
}

onMounted(() => {
  // console.clear();

// console.log("onMounted() :      Task COMMENT   >>>>");
// console.log(" prop   comment ");
  //   console.log('props : ')
// console.log(props);
// console.log({ ...props.comment });
// console.log("___________________________________________________________");

// console.log(" COMPUTED props >> ");

// console.log("canReply");
// console.log(canReply.value);
// console.log("canEdit");
// console.log(canEdit.value);
// console.log("canDelete");
// console.log(canDelete.value);

// console.log("_________comps__________________________________________________");
});
</script>

<style lang="scss" scoped>
.top-row {
  .top-left-info {
    font-weight: bold;
    font-size: large;
    //    color: #e3f4e5;
    font-style: italic;
    text-decoration: underline;
  }

  a {
    text-decoration: none;
    margin-left: 1em;
    color: rgba(255, 255, 255, 0.712);
  }
}

.taskCommentContainer {
  //  background: #849185;

  padding: 10px;
}

a.badge-success,
a.badge-warning,
a.badge-danger {
  background: #caeacd;
  color: #203486;
}

a.badge-success:hover {
  background: #72b378;
  color: #dcf1de;
}

a.badge-warning:hover {
  background: #ad9d6c;
  color: #dcf1de;
}

a.badge-danger:hover {
  background: #bd7b79;
  color: #dcf1de;
}

a.badge-warning {
  background: #caeacd;
  color: #203486;
}

a.badge-danger {
  background: #caeacd;
  color: #203486;
}

// a.badge-success:hover,
// a.badge-warning:hover,
// a.badge-danger:hover,
a.badge-success:focus,
a.badge-warning:focus a.badge-danger:focus {
  background: #caeacd;
  color: #203486;
}

a.badge:hover,
a.badge:focus {
  text-decoration: none;
  font-weight: bolder;
  // color: #eaf7ebb9;
}

.task-comments {
  //background-color: #b0c1b2;
  width: auto !important;
  box-shadow: 5px 10px 12px #888888;
  // max-width: 650px;
  // min-width: 350px;
}

.task-comment-text-box {
  width: 75%;
  margin: 0 auto;
  text-align: justify;
  font-weight: 600;
  font-size: 1em;
}

.comment {
  // this overrides ag-grids nowrap
  white-space: normal;
  //  color: white;
  font-size: 1.25em;
  padding-left: 15px;
}
</style>
